// Polyfills
import 'core-js/es5';
import 'regenerator-runtime/runtime';

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import './assets/css/instantMarketing.css';
import * as VueGoogleMaps from "vue2-google-maps";

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
    load: {
        //key: "AIzaSyAmA_z0PDxqdc_hcKxbG1BxUoSG8m2TLeQ",
        //key: "AIzaSyBKTqyt5M-1nu31UNeiIrYiDRgQUNMawPQ",
        key: "AIzaSyAh0k2rSgIv1m4-CaKrsgPAZKpy0-AgLKo",
        libraries: "places", // necessary for places input
        region: 'GB'
    }
});

new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')
